import { useContext } from "react";
import { ThemeContext } from "../Conterxts/ThemeContext";

export default function useTheme () {
    // const [IsDark, setIsDark] = useContext(ThemeContext)

    // return [IsDark, setIsDark]

    return useContext(ThemeContext)
}


// export default useTheme = () => useContext(ThemeContext)